import create from "zustand";

const readStoredUserData = () => {
    try {
        const raw = localStorage.getItem('userData');
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        localStorage.removeItem('userData');
        return null;
    }
};

const useUserStore = create((set) => ({
    isAuthenticated: localStorage.getItem('isAuthenticated') === 'true',
    setIsAuthenticated: (isAuthenticated) => {
        localStorage.setItem('isAuthenticated', isAuthenticated);
        set({ isAuthenticated });
    },
    userData: readStoredUserData(),
    setUserData: (userData) => {
        localStorage.setItem('userData', JSON.stringify(userData));
        set({ userData });
    },
}));

export default useUserStore;